/**
 * 订单产品资料 (合同订单产品一览表) — shared field presets & mappers.
 *
 * The 合同订单 records come from the one-way FileMaker sync
 * (see backend/contract_orders.py). Any module in the app can reuse the picker
 * below; each caller just maps the picked record into its own field names.
 */

export const trimNum = (n) => {
  const v = Number(n || 0);
  return Number.isFinite(v) ? String(v) : "0";
};

/** 装箱率 12 PCS/CTN | 长 48 | 宽 30 | 高 32 | 毛重 10kg | QTY/40HQ 16927 */
export function packingSummary(row, t) {
  const bits = [];
  if (row.packing_rate) bits.push(`${t("co.packingRate")} ${trimNum(row.packing_rate)} PCS/CTN`);
  if (row.length) bits.push(`${t("co.length")} ${trimNum(row.length)}`);
  if (row.width) bits.push(`${t("co.width")} ${trimNum(row.width)}`);
  if (row.height) bits.push(`${t("co.height")} ${trimNum(row.height)}`);
  if (row.gross_weight) bits.push(`${t("co.grossWeight")} ${trimNum(row.gross_weight)}kg`);
  if (row.qty_40hq) bits.push(`QTY/40HQ ${trimNum(row.qty_40hq)}`);
  return bits.join(" | ") || "-";
}

/** 紧凑版：12P | 48×30×38 | 12kg | 40HQ 14254 — 用于窄表格列。 */
export function packingSummaryCompact(row) {
  const bits = [];
  if (row.packing_rate) bits.push(`${trimNum(row.packing_rate)}P`);
  if (row.length && row.width && row.height) {
    bits.push(`${trimNum(row.length)}×${trimNum(row.width)}×${trimNum(row.height)}`);
  }
  if (row.gross_weight) bits.push(`${trimNum(row.gross_weight)}kg`);
  if (row.qty_40hq) bits.push(`40HQ ${trimNum(row.qty_40hq)}`);
  return bits.join(" | ") || "-";
}

/** Preview rows shown in the picker's right-hand panel. */
export const PACKING_PREVIEW = (t) => [
  { label: t("co.packingRate"), key: "packing_rate", unit: "PCS/CTN" },
  { label: t("co.length"), key: "length", unit: "cm" },
  { label: t("co.width"), key: "width", unit: "cm" },
  { label: t("co.height"), key: "height", unit: "cm" },
  { label: t("co.grossWeight"), key: "gross_weight", unit: "kg" },
  { label: "QTY/40HQ", key: "qty_40hq", unit: "" },
];

/** → 采购报价 form fields (procurement_quotes). */
export const toProcurementCarton = (r) => ({
  packing_rate: r.packing_rate ? String(r.packing_rate) : "",
  length: r.length || 0,
  width: r.width || 0,
  height: r.height || 0,
  gross_weight: r.gross_weight || 0,
  qty_hq: r.qty_40hq || 0,
});

/** 历史采购价 / 数量 → 工厂成本（仅在用户勾选「同时导入采购价」时使用）。 */
export const toPriceRowCost = (r) => ({ factory_cost: r.purchase_price || 0 });

/** 与当前价对比 — 返回 {diff, pct, dir} ，dir: up | down | flat | null */
export function priceDelta(historic, current) {
  const h = Number(historic || 0);
  const c = Number(current || 0);
  if (!h || !c) return null;
  const diff = c - h;
  const pct = (diff / h) * 100;
  return { diff, pct, dir: diff > 0.0001 ? "up" : diff < -0.0001 ? "down" : "flat" };
}

/** → 价格表行 / 报价单产品行 fields (price_lists & quote price rows). */
export const toPriceRowCarton = (r) => ({
  qty_per_ctn: r.packing_rate || 0,
  case_length: r.length || 0,
  case_width: r.width || 0,
  case_height: r.height || 0,
  case_weight: r.gross_weight || 0,
  container_qty_40: r.qty_40hq || 0,
});
